import React, { useState } from 'react';
import {
  Typography,
  Paper,
  Box
} from '@mui/material';

const FacilityReport = () => {
  const [selectedFacility, setSelectedFacility] = useState('');
  
  const facilities = [
    { id: 1, name: 'Shipyard Gdansk' }
  ];
  
  const allFacilities = [
    'Dock 1', 'Dock 2', 'Dock 3', 'Welding Shop', 'Assembly Hall', 
    'Paint Shop', 'Storage', 'Office', 'Crane Rail', 'Harbor Water'
  ];
  
  const projects = [
    { id: 1, name: 'Ship Alpha', color: '#2196F3' },
    { id: 2, name: 'Ship Beta', color: '#4CAF50' },
    { id: 3, name: 'Ship Gamma', color: '#FF9800' }
  ];
  
  const unitSchedule = [
    { unit: 'UNIT10', project: 'Ship Alpha', facility: 'Dock 1', startDate: '2024-01-15', endDate: '2024-02-15' },
    { unit: 'UNIT12', project: 'Ship Beta', facility: 'Dock 1', startDate: '2024-01-25', endDate: '2024-02-10' },
    { unit: 'UNIT20', project: 'Ship Beta', facility: 'Dock 1', startDate: '2024-02-20', endDate: '2024-03-20' },
    { unit: 'UNIT30', project: 'Ship Gamma', facility: 'Dock 1', startDate: '2024-03-25', endDate: '2024-04-25' },
    { unit: 'UNIT40', project: 'Ship Alpha', facility: 'Dock 2', startDate: '2024-01-10', endDate: '2024-02-10' },
    { unit: 'UNIT50', project: 'Ship Beta', facility: 'Dock 2', startDate: '2024-02-15', endDate: '2024-03-15' },
    { unit: 'UNIT60', project: 'Ship Gamma', facility: 'Dock 2', startDate: '2024-03-20', endDate: '2024-04-20' },
    { unit: 'UNIT70', project: 'Ship Alpha', facility: 'Dock 3', startDate: '2024-01-05', endDate: '2024-02-05' },
    { unit: 'UNIT80', project: 'Ship Beta', facility: 'Dock 3', startDate: '2024-02-10', endDate: '2024-03-10' },
    { unit: 'UNIT11', project: 'Ship Gamma', facility: 'Welding Shop', startDate: '2024-01-20', endDate: '2024-02-20' },
    { unit: 'UNIT13', project: 'Ship Alpha', facility: 'Welding Shop', startDate: '2024-02-05', endDate: '2024-02-25' },
    { unit: 'UNIT21', project: 'Ship Alpha', facility: 'Welding Shop', startDate: '2024-03-01', endDate: '2024-03-25' },
    { unit: 'UNIT31', project: 'Ship Beta', facility: 'Assembly Hall', startDate: '2024-01-05', endDate: '2024-02-05' },
    { unit: 'UNIT41', project: 'Ship Gamma', facility: 'Assembly Hall', startDate: '2024-02-10', endDate: '2024-03-10' },
    { unit: 'UNIT51', project: 'Ship Alpha', facility: 'Paint Shop', startDate: '2024-01-25', endDate: '2024-02-25' },
    { unit: 'UNIT53', project: 'Ship Beta', facility: 'Paint Shop', startDate: '2024-02-28', endDate: '2024-03-28' },
    { unit: 'UNIT61', project: 'Ship Gamma', facility: 'Storage', startDate: '2024-01-15', endDate: '2024-02-15' },
    { unit: 'UNIT71', project: 'Ship Alpha', facility: 'Harbor Water', startDate: '2024-01-20', endDate: '2024-02-20' },
    { unit: 'UNIT81', project: 'Ship Beta', facility: 'Harbor Water', startDate: '2024-02-25', endDate: '2024-03-25' }
  ];
  
  const selectedFacilityData = facilities.find(f => f.id === parseInt(selectedFacility));
  
  const getDaysBetween = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    return Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
  };
  
  const getPositionFromStart = (facilityStart, itemStart) => {
    const facilityStartDate = new Date(facilityStart);
    const itemStartDate = new Date(itemStart);
    return Math.ceil((itemStartDate - facilityStartDate) / (1000 * 60 * 60 * 24));
  };
  
  const getProjectColor = (projectName) => {
    const project = projects.find(p => p.name === projectName);
    return project ? project.color : '#9E9E9E';
  };
  
  const facilityStartDate = '2024-01-01';
  const facilityEndDate = '2024-06-30';
  const totalDays = getDaysBetween(facilityStartDate, facilityEndDate);
  
  const filteredUnits = selectedFacilityData ? unitSchedule : [];
  const facilitiesToShow = selectedFacilityData ? allFacilities : [];
  
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Facility Report
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Unit Schedule by Facility
        </Typography>
        
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <select 
            value={selectedFacility} 
            onChange={(e) => setSelectedFacility(e.target.value)}
            style={{ padding: '8px', fontSize: '14px', minWidth: '200px' }}
          >
            <option value="">Select Facility</option>
            {facilities.map(facility => (
              <option key={facility.id} value={facility.id}>{facility.name}</option>
            ))}
          </select>
          
          <Box sx={{ display: 'flex', gap: 3 }}>
            {projects.map(project => (
              <Box key={project.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 20, height: 12, backgroundColor: project.color, borderRadius: 1 }} />
                <Typography variant="caption">{project.name}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
        
        {selectedFacility && selectedFacilityData && (
          <Box sx={{ overflowX: 'auto' }}>
            <Box sx={{ minWidth: 1200 }}>
              {/* Header with monthly divisions */}
              <Box sx={{ display: 'flex', mb: 1 }}>
                <Box sx={{ width: 150, flexShrink: 0 }}></Box>
                <Box sx={{ flex: 1, display: 'flex' }}>
                  {Array.from({ length: 6 }, (_, i) => {
                    const monthDate = new Date(facilityStartDate);
                    monthDate.setMonth(monthDate.getMonth() + i);
                    const monthStr = monthDate.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
                    return (
                      <Box key={i} sx={{ 
                        flex: 1, 
                        textAlign: 'center', 
                        borderRight: '1px solid #e0e0e0',
                        py: 1
                      }}>
                        <Typography variant="caption" color="text.secondary">
                          {monthStr}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
              
              {/* Timeline rows */}
              {facilitiesToShow.map((facilityName, facilityIndex) => {
                const facilityUnits = filteredUnits.filter(unit => unit.facility === facilityName);
                
                return (
                  <Box key={facilityIndex} sx={{ mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <Box sx={{ width: 150, flexShrink: 0, pr: 2 }}>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                          {facilityName}
                        </Typography>
                      </Box>
                      <Box sx={{ flex: 1, position: 'relative', height: 50, border: '2px solid #1976d2', mx: 2, display: 'flex', backgroundColor: '#f5f5f5' }}>
                        {/* Monthly grid lines */}
                        {Array.from({ length: 6 }, (_, i) => (
                          <Box key={i} sx={{ 
                            flex: 1, 
                            borderRight: i < 5 ? '1px solid #e0e0e0' : 'none',
                            position: 'relative'
                          }}>
                            {/* Units in this facility */}
                            {facilityUnits.map((unit, unitIndex) => {
                              const unitStartPos = getPositionFromStart(facilityStartDate, unit.startDate);
                              const unitDuration = getDaysBetween(unit.startDate, unit.endDate);
                              const projectColor = getProjectColor(unit.project);
                              
                              return i === 0 && (
                                <Box key={unitIndex} sx={{
                                  position: 'absolute',
                                  left: `${(unitStartPos / totalDays) * 600}%`,
                                  width: `${(unitDuration / totalDays) * 600}%`,
                                  height: '18px',
                                  top: `${5 + (unitIndex * 8)}px`,
                                  backgroundColor: projectColor,
                                  borderRadius: 1,
                                  zIndex: 2 + unitIndex,
                                  border: `1px solid ${projectColor}`,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  opacity: 0.9
                                }}>
                                  <Typography variant="caption" sx={{ color: 'white', fontSize: '8px', fontWeight: 'bold' }}>
                                    {unit.unit}
                                  </Typography>
                                </Box>
                              );
                            })}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                );
              })}
              
              {filteredUnits.length === 0 && selectedFacility && (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                  <Typography color="text.secondary">
                    No units scheduled for {selectedFacilityData.name}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Paper>
    </div>
  );
};

export default FacilityReport;